<template>
  <div>
    <!-- แถบแรก -->
    <b-card no-body>
      <div class="card-content">
        <b-card-body>
          <h4 class="card-title">
            ข้อมูล User
          </h4>
          <hr />
          <div class="mt-3" />
          <b-row>
            <b-col cols="md-4">
              <b-form-group>
                <label class="control-label">Username</label>
                <input type="text" v-model="result.username" class="form-control" placeholder="ข้อมูลเบอร์มือถือ" readonly>
              </b-form-group>
            </b-col>
            <b-col cols="md-4">
              <b-form-group>
                <label class="control-label">ชื่อบัญชี</label>
                <input type="text" v-model="result.full_name" class="form-control" placeholder="ข้อมูลชื่อบัญชี" readonly>
              </b-form-group>
            </b-col>
            <b-col cols="md-4">
              <b-form-group>
                <label class="control-label">Line</label>
                <input type="text" v-model="result.line_id" class="form-control" placeholder="ข้อมูล Line" readonly>
              </b-form-group>
            </b-col>
            <b-col cols="md-4">
              <b-form-group>
                <label class="control-label">Username (member)</label>
                <input type="text" v-model="result.account_agent_username" class="form-control" placeholder="ข้อมูล Username (member)" readonly>
              </b-form-group>
            </b-col>
            <b-col cols="md-4">
              <b-form-group>
                <label class="control-label">Password (member)</label>
                <input type="text" v-model="result.account_agent_password" class="form-control" placeholder="ข้อมูล Password (member)" readonly>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </div>
    </b-card>
    <!-- สิ้นสุดแถบแรก -->
    <b-card no-body>
      <div class="card-content">
        <b-card-body>
          <h4 class="card-title">
            ข้อมูลธนาคาร
          </h4>
          <hr />
          <div class="mt-3" />
          <b-row>
            <b-col cols="md-4">
              <b-form-group>
                <label class="control-label">ธนาคาร</label>
                <b-form-select v-model="result.bank" :options="option_bank" disabled/>
              </b-form-group>
            </b-col>
            <b-col cols="md-4">
              <b-form-group>
                <label class="control-label">เลขบัญชี</label>
                <input type="text" v-model="result.bank_number" class="form-control" placeholder="ข้อมูลเลขบัญชี" readonly>
              </b-form-group>
            </b-col>
            <b-col cols="md-4">
              <b-form-group>
                <label class="control-label">ชื่อบัญชี</label>
                <input type="text" v-model="result.full_name" class="form-control" placeholder="ข้อมูลชื่อบัญชี" readonly>
              </b-form-group>
            </b-col>
            <b-col cols="md-4">
              <b-form-group>
                <label class="control-label">จำนวนเงิน</label>
                <input type="text" v-model="result.amount" class="form-control" placeholder="ข้อมูลจำนวนเงิน" readonly>
              </b-form-group>
            </b-col>
            <b-col cols="md-4">
              <b-form-group>
                <label class="control-label">ถอนเมื่อ</label>
                <input type="text" v-model="result.created_at" class="form-control" placeholder="ข้อมูลถอนเมื่อ" readonly>
              </b-form-group>
            </b-col>
            <b-col cols="md-4">
              <b-form-group>
                <label class="control-label">หมายเหตุ</label>
                <input type="text" v-model="result.max_value" class="form-control" placeholder="หมายเหตุ" readonly>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="md-12">
              <b-form-group>
                <label class="control-label">Response api</label>
                <textarea type="text" v-model="result.max_value" class="form-control" placeholder="{}" cols="3"></textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="md-12">
              <div class="text-right m-b-10">
                <div class="text-right m-b-10">
                  <router-link :to="PATH" class="btn bg-gradient-warning waves-effect waves-light mr-1"><span><feather-icon icon="ArrowLeftIcon" class="font-medium-1 mr-1" /></span>ย้อนกลับ</router-link>
                  <button @click="slip()" type="submit" class="btn bg-gradient-primary waves-effect waves-light text-white"><span><feather-icon icon="ImageIcon" class="font-medium-1 mr-1" /></span>ดูสลิป</button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </div>
    </b-card>
    <!-- สิ้นสุดท้าย -->
    <div id="qr" />
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCol, BRow, BTable, BFormGroup, BFormSelect,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import moment from 'moment'
import 'moment/locale/th'
moment.locale('th')
import '@/assets/plugins/qrcode/qrcode.js'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCol,
    BRow,
    BTable,
    BFormGroup,
    BFormSelect,
    vSelect,
  },
  data() {
    return {
      PATH: '/withdraw',
      BASE_URL: process.env.BASE_URL,
      API_GET_URL: 'withdraw/withdraw_detail/' + this.$route.params.id,
      result: {
        username: '',
        full_name: '',
        line_id: '',
        account_agent_username: '',
        account_agent_password: '',
        bank: '',
        bank_number: '',
        bank_name: 1,
        amount: 1,
        created_at: '',
        max_value: '',
      },
      option_bank: [
        { text: 'ธนาคารกรุงเทพ จำกัด (มหาชน)', value: '01' },
        { text: 'ธนาคารกสิกรไทย จำกัด (มหาชน)', value: '02' },
        { text: 'ธนาคารกรุงไทย จำกัด (มหาชน)', value: '03' },
        { text: 'ธนาคารทหารไทยธนชาต จำกัด (มหาชน)', value: '04' },
        { text: 'ธนาคารไทยพาณิชย์ จำกัด (มหาชน)', value: '05' },
        { text: 'ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)', value: '06' },
        { text: 'ธนาคารออมสิน จำกัด (มหาชน)', value: '07' },
        { text: 'ธนาคารธนชาติ จำกัด (มหาชน)', value: '08' },
        { text: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร จำกัด (มหาชน)', value: '09' },
      ],
      option: [
        { text: 'ปิด', value: '0' },
        { text: 'เปิด', value: '1' },
      ],
      bank_admin: {'01': '1', '02': '2', '03': '3', '04': '5', '05': '6', '06': '4', '07': '7', '08': '9', '09': 'baac'},
      bank_list: JSON.parse('{"01":"\u0e01\u0e23\u0e38\u0e07\u0e40\u0e17\u0e1e","02":"\u0e01\u0e2a\u0e34\u0e01\u0e23\u0e44\u0e17\u0e22","03":"\u0e01\u0e23\u0e38\u0e07\u0e44\u0e17\u0e22","04":"\u0e17\u0e2b\u0e32\u0e23\u0e44\u0e17\u0e22","05":"\u0e44\u0e17\u0e22\u0e1e\u0e32\u0e13\u0e34\u0e0a\u0e22\u0e4c","06":"\u0e01\u0e23\u0e38\u0e07\u0e28\u0e23\u0e35\u0e2d\u0e22\u0e38\u0e18\u0e22\u0e32","07":"\u0e2d\u0e2d\u0e21\u0e2a\u0e34\u0e19","08":"\u0e18\u0e19\u0e0a\u0e32\u0e15\u0e34","09":"\u0e18.\u0e01.\u0e2a.","1":"\u0e01\u0e23\u0e38\u0e07\u0e40\u0e17\u0e1e","2":"\u0e01\u0e2a\u0e34\u0e01\u0e23\u0e44\u0e17\u0e22","3":"\u0e01\u0e23\u0e38\u0e07\u0e44\u0e17\u0e22","4":"\u0e17\u0e2b\u0e32\u0e23\u0e44\u0e17\u0e22","5":"\u0e44\u0e17\u0e22\u0e1e\u0e32\u0e13\u0e34\u0e0a\u0e22\u0e4c","6":"\u0e01\u0e23\u0e38\u0e07\u0e28\u0e23\u0e35\u0e2d\u0e22\u0e38\u0e18\u0e22\u0e32","7":"\u0e2d\u0e2d\u0e21\u0e2a\u0e34\u0e19","8":"\u0e18\u0e19\u0e0a\u0e32\u0e15\u0e34","9":"\u0e18.\u0e01.\u0e2a."}'),
    }
  },
  mounted() {
    this.fetch()
    $(document).on('click', '#cv', () => {
      var cv = document.getElementById('cv');
      var dl = document.createElement('a')
      dl.download = `${this.result.transactionId}.png`;
      dl.href = cv.toDataURL('image/png', 1.0);
      dl.click();
    });
  },
  methods: {
    moment(date) {
      return moment(date).format('D MM YYYY - HH:mm')
    },
    toMoney(value) {
      const parts = parseFloat(value).toFixed(2).split('.')
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + (parts[1] ? `.${parts[1]}` : '')
    },
    loading() {
      this.$swal({
			  text: "กรุณารอสักครู่..",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: '',
        onBeforeOpen: () => {
          this.$swal.showLoading()
        },
      });
    },
    fetch() {
      this.$http.get(this.API_GET_URL).then(res => {
        if (res.data != null && res.data.result != null) {
          this.result = res.data.result
          this.result.bank_code = this.option_bank.find(b=>b.value==this.result.bank_code)
          if (this.result.QRstring == null) {
            var trans = JSON.parse(this.result.max_value);
            if (trans && trans.result && trans.result.data && trans.result.data.additionalMetaData) {
              this.result.QRstring = trans.result.data.additionalMetaData.paymentInfo[0].QRstring;
            }
          }
        }
        else this.$router.push(this.PATH)
      }).catch(()=>this.$router.push(this.PATH))
    },
    slip() {
      let html = 'ผู้รับเงินสามารถสแกนคิวอาร์โค้ดนี้เพื่อตรวจสอบสถานะการโอนเงิน'
      let html2 = 'ไม่สามารถดูสลิปโอนเงินยอดนี้ได้ค่ะ'
      let has_slip = (this.result.QRstring != null && this.result.QRstring != '')
      if (has_slip) {
        html = `<div class="mt-1"><canvas id="cv" width="860" height="1337" /></div><br>${html}`
      }
      let preview = (has_slip) ? html : html2
      this.$swal({
        title: '<span class="font-weight-bolder">สลิปโอนเงิน</span>',
        icon: has_slip ? 'success' : 'info',
        html: preview,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'ดูเรียบร้อย',
        cancelButtonText: 'ปิดหน้าต่าง',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
      this.generate()
    },
    QRCode(id, qr_string) {
      return new QRCode($(id)[0], {
          text: qr_string,
          width: 170,
          height: 170
      })
    },
    get_from_bank(code) {
      return this.bank_admin[code] != null ?  this.bank_admin[code] : `0`;
    },
    generate() {
      String.prototype.splice = function(idx, rem, str) {
        return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem))
      }
      let qr_string = this.result.QRstring
      let bg = '/assets/app-assets/images/bank/qrcode.png'
      let from_bank = `/assets/app-assets/images/bank/${this.get_from_bank(this.result.from_bank)}.png`
      let from_name = this.result.from_bank_name
      let from_number = this.result.from_bank_number
      let from_start = "x".repeat(from_number.slice(4).length)
      let from_end = from_number.slice(-4)
      let from_to = from_start.splice(3, 0, "-") + from_end.splice(3, 0, "-")
      let to_bank = `/assets/app-assets/images/bank/${this.get_from_bank(this.result.bank)}.png`
      let to_name = this.result.full_name
      let to_number = this.result.bank_number
      let to_end = to_number.slice(-4)
      let to_to = "x-" + to_end
      let amount = this.toMoney(this.result.amount)
      let refer = this.result.transactionId
      let datetime = this.moment(this.result.transactionDateTime)
      var qrimg = this.QRCode('#qr', qr_string);
      var cv = document.getElementById('cv');
      var ct = cv.getContext('2d');
      var imageObj = new Image();
      imageObj.onload = function(){
        ct.drawImage(imageObj, 0, 0);
        //date
        ct.fillStyle = 'Gray';
        ct.font = "18pt Arial";
        ct.textAlign = "center";
        ct.fillText(datetime, 430, 349);
        //ref code
        ct.font = "18pt Arial";
        ct.textAlign = "start";
        ct.fillText(refer, 317, 397);
        //from bank
        ct.fillStyle = 'Black';
        ct.font = "27pt Mitr";
        ct.textAlign = "end";
        ct.fillText(from_name, 810, 514);
        var from_w = ct.measureText(from_name).width;
        //from number
        ct.fillStyle = 'Gray';
        ct.font = "18pt Arial";
        ct.textAlign = "end";
        ct.fillText(from_to, 810, 566);
        //to bank
        ct.fillStyle = 'Black';
        ct.font = "27pt Mitr";
        ct.textAlign = "end";
        ct.fillText(to_name, 810, 644);
        var to_w = ct.measureText(to_name).width;
        //to number
        ct.fillStyle = 'Gray';
        ct.font = "18pt Arial";
        ct.textAlign = "end";
        ct.fillText(to_to, 810, 698);
        //money
        ct.fillStyle = 'Black';
        ct.font = "21pt Arial";
        ct.textAlign = "end";
        ct.fillText(amount, 810, 821);
        
        let from_offset = from_w + 20;
        ct.save();
        ct.arc(800-from_offset, 503, 20, 20, Math.PI*2,true);
        ct.clip();
        var fromObj = new Image();
        fromObj.onload = function(){
          ct.drawImage(this, 779-from_offset, 482, 42, 42);
          ct.fillStyle = ct.createPattern(this, 'no-repeat');
          ct.fill();
          ct.restore();

          let to_offset = to_w + 20;
          ct.save();
          ct.arc(800-to_offset, 633, 20, 20, Math.PI*2,true);
          ct.clip();
          var toObj = new Image();
          toObj.onload = function(){
            ct.drawImage(this, 779-to_offset, 612, 42, 42);
            ct.fillStyle = ct.createPattern(this, 'no-repeat');
            ct.fill();
            ct.restore();

            var qrObj = new Image();
            qrObj.onload = function(){
              ct.drawImage(this, 639, 899)
            };
            qrObj.src = qrimg._oDrawing._elCanvas.toDataURL("image/png")
          }
          toObj.src = to_bank
        }
        fromObj.src = from_bank
      };
      imageObj.src = bg
    },
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Mitr:wght@300&display=swap');
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
#qr {
  display: none;
  position: fixed;
}
#cv {
  width: 100%;
  height: 100%;
}
</style>
